import { render, staticRenderFns } from "./LeagueTeamForm.vue?vue&type=template&id=323a3adb&scoped=true"
import script from "./LeagueTeamForm.vue?vue&type=script&lang=js"
export * from "./LeagueTeamForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323a3adb",
  null
  
)

export default component.exports